import React, { createContext, useContext, useState } from 'react';

const PageTitleContext = createContext();

export const PageTitleProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('');
  const [pageSubTitle, setPageSubTitle] = useState('');

  return (
    <PageTitleContext.Provider value={{ pageTitle, setPageTitle, pageSubTitle, setPageSubTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
};

export const usePageTitle = () => {
  return useContext(PageTitleContext);
};
